import {
  JobInfoViewActionButton,
} from 'types/jobs';

import { JobInfoViewActionButtonType, PaymentStatus } from 'constants/enums';
import { DEFAULT_JOBS_INFO_VIEW_ALERT_SETTINGS } from 'constants/jobsSettings';

import { JobInfoViewPaymentStatusConfig } from '../config/jobInfoViewConfig';

const ACTIVE_SUBSCRIPTION_ACTION_BUTTON_COL_SPAN = {
  xl: 24,
  sm: 24,
  xs: 24
} as const;

const DEFAULT_ACTION_BUTTON_COL_SPAN = {
  xl: 6,
  sm: 12,
  xs: 24
} as const;

type GetJobInfoViewStateParams = {
  isFreeJob: boolean;
  subscriptionStatus?: PaymentStatus | null;
  config: Record<PaymentStatus, JobInfoViewPaymentStatusConfig>;
};

type JobInfoViewState = {
  alertType: JobInfoViewPaymentStatusConfig['alertType'];
  alertText: JobInfoViewPaymentStatusConfig['alertText'];
  actionButton: JobInfoViewActionButton | null;
  alertButton: JobInfoViewActionButton | null;
  actionButtonColSpan:
    | typeof ACTIVE_SUBSCRIPTION_ACTION_BUTTON_COL_SPAN
    | typeof DEFAULT_ACTION_BUTTON_COL_SPAN;
  isAdditionalUpdatePaymentButton: boolean;
};

export const getJobInfoViewState = ({
  isFreeJob,
  subscriptionStatus,
  config
}: GetJobInfoViewStateParams): JobInfoViewState => {
  const fallbackSettings = DEFAULT_JOBS_INFO_VIEW_ALERT_SETTINGS;
  const statusSettings =
    !isFreeJob && subscriptionStatus
      ? (config[subscriptionStatus] ?? fallbackSettings)
      : fallbackSettings;
  const actionButton = subscriptionStatus
    ? (config[subscriptionStatus]?.actionButton ?? null)
    : null;

  return {
    alertType: statusSettings.alertType,
    alertText: statusSettings.alertText,
    actionButton,
    alertButton: subscriptionStatus
      ? (config[subscriptionStatus]?.alertButton ?? null)
      : null,
    actionButtonColSpan:
      subscriptionStatus === PaymentStatus.Active
        ? ACTIVE_SUBSCRIPTION_ACTION_BUTTON_COL_SPAN
        : DEFAULT_ACTION_BUTTON_COL_SPAN,
    isAdditionalUpdatePaymentButton:
      !isFreeJob &&
      actionButton?.key !== JobInfoViewActionButtonType.UpdatePayment
  };
};
